import { computed } from "vue";

// Changelog data stored directly
const changelogData = `2/26/26 - Loading improvements via tree shaking components and changes to home page visuals.
2/14/25 - An Overview widget has been added to the Dashboard view, showing click metrics at a glance.
2/13/25 - Hover tooltips for the email hash and PIN have been added in the Reviewers tab, along with other subtle styling fixes.
2/4/25 - Stripe and Square temporarily disabled for ongoing portal redesign.
10/6/24 - Introduction of square payment method and various bug fixes.
7/20/24 - An update to optimize QuickBooks payments processing, and a refinement of the Stripe payment processing.
5/2/24 - The PIN search has been upgraded to access all PINs all of the time. Hitting Enter on the keyboard selects the top result. 
2/18/24 - Option added to select how many reviewers are shown on each page of the reviewers table. This should help with loading times.
12/28/23 - Embedding the review portal on your personal/business site is now possible, the new option is 'Embed Settings' in the Settings page.
12/17/23 - Hovering over the 'Views' value will display the dates and times of link review visits. This will only work for newly created links.
12/1/23 - Reviewers are given a choice of where to review before being redirected.
11/29/23 - A review can be reset by clicking on the checkmark in the review column of a completed review. 
11/4/23 - A claimed payment can now be unset by clicking on the 'C' in the respective Reviewers table row.
10/26/23 - A modification to the tracking system was made to send click info every 15 seconds.
10/23/23 - A basic tracking system has been introduced, visible for each row in the Reviewers table.
10/17/23 - Refined the Copy Linked Image logic and added a view toggle in the Reviewers table, as well as a date created column.
10/14/23 - Added a link view tracking metric in the reviewers table and made multiple aesthetics enhancements.
10/6/23 - Added a field in settings for a review portal image url. More info in FAQ.
10/4/23 - The Reviewers table is now sortable by the Paid and # columns.
10/4/23 - A running ChangeLog is now visible under the Help section and the first two lines are visible in the Dashboard view.
10/3/23 - Claiming reviewer payments can now be done internally (check FAQ).
10/3/23 - The Reviews view and Dashboard view now exclude archived reviewers/reviews.`;

export const useChangelog = () => {
  const allLines = changelogData.split("\n");

  return {
    recentUpdates: computed(() => allLines.slice(0, 2).join(" <br /> ")),
    allUpdates: computed(() => allLines.join(" <br /> ")),
  };
};
